import React from 'react';
import { Link } from 'gatsby';

interface InlineCTAProps {
  type: 'free' | 'paid';
  title?: string;
  description?: string;
  ctaText?: string;
  ctaLink?: string;
}

const InlineCTA: React.FC<InlineCTAProps> = ({ type, title, description, ctaText, ctaLink }) => {
  const defaultContent = {
    free: {
      title: 'Score this against your own organisation',
      description:
        'Take the AI Enablement Maturity Diagnostic — 25 questions across the five pillars (production function, data layer, decision systems, operating model, governance). Per-pillar breakdown and prioritised next steps in 5 minutes.',
      ctaText: 'Take the diagnostic',
      ctaLink: '/ai-enablement-maturity',
    },
    paid: {
      title: 'Ready to do the structural work?',
      description:
        'Our AI Enablement engagements are built around the five pillars in this article. We start with a focused diagnostic, then redesign one priority workflow end-to-end as proof — including the data layer, decision rights, and governance machinery.',
      ctaText: 'Explore the AI Enablement service',
      ctaLink: '/services/ai-enablement',
    },
  };

  const content = defaultContent[type];

  return (
    <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-8 my-10 shadow-sm">
      <h3 className="text-2xl font-bold mb-3 text-primary-900 leading-snug">
        {title || content.title}
      </h3>
      <p className="text-gray-600 mb-6 leading-relaxed">
        {description || content.description}
      </p>
      <Link
        to={ctaLink || content.ctaLink}
        className={type === 'paid' ? 'btn-primary' : 'btn-secondary'}
      >
        {ctaText || content.ctaText}
      </Link>
    </div>
  );
};

export default InlineCTA;
